/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Search sprites by name",
  "description": "Adds a search box to the sprite pane to search for sprites by name.",
  "credits": [
    {
      "name": "BarelySmooth",
      "link": "https://scratch.mit.edu/users/BarelySmooth/"
    },
    {
      "name": "GarboMuffin"
    }
  ],
  "userstyles": [
    {
      "url": "search-bar.css"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "dynamicDisable": true,
  "tags": [],
  "enabledByDefault": false
};
export default manifest;
